/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import clone from 'clone';
import moment from 'moment-timezone';
import {
  Button,
  Dropdown,
  Grid,
  Header,
  Icon,
  Label,
  List,
  Segment,
  Step,
  Image,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import { fetchBankCaseStates } from '../../actions/bankCaseStates';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import Timestamp from '../../components/Timestamp';
import BankersList from '../modals/BankersList';
import InviteBankerForm from '../modals/InviteBankerForm';
import UpdateCaseStatus from '../modals/UpdateCaseStatus';
import GetStarted from './GetStarted';
import CurrencySymbol from '../../components/CurrencySymbol';
import LoanAmount from '../../components/LoanAmount';
import Phone from '../../components/Phone';
import { decodeSearch, encodeSearch } from '../../utils/url';
import { bankCaseLoanAmount, bankCaseLoanAmountPayload, loanMarginPercent } from '../../utils/loanAmount';
import icPreferredGreen from '../../assets/icons/ic_preferred_green.svg';
import BankCaseStates from '../modals/BankCaseStates';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import HLBCampaignCalloutBanner from '../../components/HLBCampaign/HLBCampaignCalloutBanner';

class LoanTracker extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      companyBranch: PropTypes.object,
    }),
    allBankCases: PropTypes.arrayOf(PropTypes.object),
    bankCases: PropTypes.arrayOf(PropTypes.object),
    bankCaseStates: PropTypes.shape({
      data: PropTypes.array,
    }),
    bankerOnCheck: PropTypes.func,
    bankerSelectionTabs: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    bookingID: PropTypes.string,
    bookingStatusID: PropTypes.string,
    bookingSPAValue: PropTypes.number,
    consentTypeID: PropTypes.string,
    disabled: PropTypes.bool,
    hasDropCase: PropTypes.bool,
    hasSuccessBankCase: PropTypes.bool,
    isCashBuyer: PropTypes.bool,
    isNotAuthorizedToInviteBanker: PropTypes.bool,
    loanTrackerLeadDropID: PropTypes.number,
    loanTrackerLeadID: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    leadBankersLimit: PropTypes.number,
    leadStatus: PropTypes.string,
    loanTrackerLeadCode: PropTypes.string,
    loanTrackerLeadConsentPinCount: PropTypes.number,
    loanTrackerLeadConsentPinExpiresAt: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }).isRequired,
    mobile: PropTypes.string,
    mobilePrefix: PropTypes.string,
    preferredName: PropTypes.string,
    projectAssignBankCasesStatus: PropTypes.string,
    projectCurrencies: PropTypes.string,
    projectID: PropTypes.string,
    setLoading: PropTypes.func.isRequired,
    token: PropTypes.string,
    onBankerAssignmentSuccess: PropTypes.func,
    project: PropTypes.shape({
      hlbCampaignIsEnabled: PropTypes.bool,
    }),
  }
  static defaultData = {
    id: 0,
    leadDropID: 0,
    code: null,
    pinExpiresAt: null,
    consentPinCount: 0,
    leadBankersLimit: 0,
  }
  static mapStateToProps = state => ({
    bankCaseStates: state.bankCaseStates,
  })
  static getPropsToState = (props) => {
    const bookingStatusID = props.bookingStatusID;
    const bookingSPAValue = props.bookingSPAValue;
    const hasDropCase = props.hasDropCase;
    const projectAssignBankCasesStatus = props.projectAssignBankCasesStatus;
    const projectCurrencies = props.projectCurrencies;
    const isCashBuyer = props.isCashBuyer || false;
    const preferredName = props.preferredName;

    return {
      bookingStatusID,
      bookingSPAValue,
      hasDropCase,
      projectAssignBankCasesStatus,
      projectCurrencies,
      isCashBuyer,
      preferredName,
    };
  }
  constructor(props) {
    super(props);
    const state = LoanTracker.getPropsToState(props);
    const {
      id,
      leadDropID,
      pinExpiresAt,
      consentPinCount,
      code,
      leadBankersLimit,
    } = LoanTracker.defaultData;
    const allBankCases = [].concat(props.allBankCases);
    const bankCases = [].concat(props.bankCases);
    this.state = {
      ...state,
      id: props.loanTrackerLeadID || id,
      leadDropID: props.loanTrackerLeadDropID || leadDropID,
      code: props.loanTrackerLeadCode || code,
      pinExpiresAt: props.loanTrackerLeadConsentPinExpiresAt || pinExpiresAt,
      consentPinCount: props.loanTrackerLeadConsentPinCount || consentPinCount,
      leadBankersLimit: props.leadBankersLimit || leadBankersLimit,
      showAddBanker: false,
      additionalBankers: [],
      bankersCount: 0,
      allBankCases,
      bankCases,
      oriAllBankCases: clone(allBankCases),
      oriBankCases: clone(bankCases),
      selectedBankCase: null,
      updateStatus: '',
      showUpdateBankCase: false,
      showInviteBanker: false,
      showBankCaseStatesModal: false,
      displayAddBankerContent: true,
      selectedCaseStatus: '',
    };
  }
  componentWillMount() {
    const { store } = this.context;
    if (this.props.bankCaseStates.data.length < 14) {
      store.dispatch(fetchBankCaseStates());
    }
  }
  componentWillReceiveProps(props) {
    const state = LoanTracker.getPropsToState(props);
    const {
      id,
      leadDropID,
      pinExpiresAt,
      consentPinCount,
      code,
      leadBankersLimit,
    } = LoanTracker.defaultData;
    let {
      allBankCases,
      bankCases,
      hasDropCase,
      oriAllBankCases,
      oriBankCases,
    } = this.state;

    if (JSON.stringify(oriBankCases) !== JSON.stringify(props.bankCases)) {
      bankCases = props.bankCases || [];
      oriBankCases = clone(bankCases);
    }
    if (JSON.stringify(oriAllBankCases) !== JSON.stringify(props.allBankCases)) {
      allBankCases = props.allBankCases || [];
      oriAllBankCases = clone(allBankCases);
    }
    if (hasDropCase !== props.hasDropCase) {
      hasDropCase = props.hasDropCase;
    }

    this.setState({
      id: props.loanTrackerLeadID || id,
      leadDropID: props.loanTrackerLeadDropID || leadDropID,
      code: props.loanTrackerLeadCode || code,
      pinExpiresAt: props.loanTrackerLeadConsentPinExpiresAt || pinExpiresAt,
      consentPinCount: props.loanTrackerLeadConsentPinCount || consentPinCount,
      leadBankersLimit: props.leadBankersLimit || leadBankersLimit,
      allBankCases,
      bankCases,
      hasDropCase,
      oriAllBankCases,
      oriBankCases,
      ...state,
    }, () => {
      this.checkBankCasesActivity(allBankCases);
    });
  }
  getColor = (status) => {
    if (status.startsWith('reject')) {
      return 'red';
    } else if (status.startsWith('pending')) {
      return 'yellow';
    } else if (status.startsWith('approved') || status.startsWith('success')) {
      return 'green';
    }
    return 'blue';
  }
  getLoanMargin = (loanAmount) => {
    const { bookingSPAValue } = this.state;
    return `${loanMarginPercent(loanAmount, bookingSPAValue)}%`;
  }
  getPendingDeveloperApprovalCaseColor = () => {
    const { bookingStatusID } = this.props;
    if (bookingStatusID === 'cancelled_developer' ||
    bookingStatusID === 'cancelled_availability' ||
    bookingStatusID === 'expired') {
      return 'red';
    }
    return 'blue';
  }
  getCaseText = (leadDropID, status) => {
    const { bookingStatusID } = this.props;
    if (leadDropID > 0) {
      if (bookingStatusID === 'cancelled_developer' ||
      bookingStatusID === 'cancelled_availability' ||
      bookingStatusID === 'expired') {
        return 'Cancelled by developer';
      }
      return 'New';
    }

    switch (status) {
      case 'new':
        return 'New';
      case 'pending_docs':
        return 'Pending Docs';
      case 'pending_docs_submitted':
        return 'Docs Submitted';
      case 'approved_lo_issued':
        return 'LO Issued';
      case 'pending_unreachable':
        return 'Unreachable';
      case 'pending_reappealed':
        return 'Loan Re-appealed';
      case 'reject_wrong_info':
        return 'Wrong Info';
      case 'reject_cancelled':
        return 'Customer Cancelled';
      case 'success_li_issued':
        return 'LO Signed';
      case 'reject_unqualified':
        return 'Unqualified';
      case 'reject_bank':
        return 'Loan Rejected';
      case 'reject_customer':
        return 'Customer Rejected';
      case 'reject_lo_signed_other_bank':
        return 'LO Signed With Another Bank';
      case 'reject_developer':
        return 'Developer Cancelled';
      default:
        return '';
    }
  }
  setLoading = (loading = false) => {
    if (this.props.setLoading) {
      return this.props.setLoading(loading);
    }
    return Promise.resolve();
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  async addBanker(newBankCases, isDrop = false) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({
      drop: isDrop ? 'true' : 'false',
    });
    try {
      const res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/loan_trackers/bank_cases/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify({
          bankCases: newBankCases,
        }),
      }));
      if (res.ok) {
        await this.setComponentState({
          additionalBankers: [],
          showAddBanker: false,
        });
        store.dispatch(flashSuccessMessage({
          header: t('Add Success', { ns: TRANSLATION_FILES.translation }),
          message: `${t('Banker(s) is successfully added', { ns: TRANSLATION_FILES.translation })}.`,
        }));
        if (this.props.onBankerAssignmentSuccess) {
          await this.props.onBankerAssignmentSuccess();
        }
      } else {
        const message = await res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      } else {
        Bugsnag.notifyException(err);
        store.dispatch(flashErrorMessage({
          message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.`,
        }));
      }
    } finally {
      await this.setLoading(false);
    }
  }
  async inviteBanker(validations, newBanker) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const { bookingStatusID, projectAssignBankCasesStatus } = this.state;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    await this.setComponentState({ showInviteBanker: false });
    const query = Object.assign({
      drop: projectAssignBankCasesStatus !== '' && projectAssignBankCasesStatus === 'booked' && bookingStatusID === 'reserved' ? 'true' : 'false',
    });
    try {
      await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/loan_trackers/bank_cases/invite/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(newBanker),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    await this.setComponentState({ showAddBanker: false });
    window.location.reload();
    store.dispatch(flashSuccessMessage({
      header: t('Invite Success', { ns: TRANSLATION_FILES.translation }),
      message: `${t('Banker {{name}} is successfully invited', { name: newBanker.name, ns: TRANSLATION_FILES.translation })}.`,
    }));
  }
  async updateBankCase(statusNote = '', loanAmount = '0') {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const { selectedBankCase, updateStatus } = this.state;
    const body = Object.assign(selectedBankCase, bankCaseLoanAmountPayload(loanAmount), {
      status: updateStatus,
      statusNote,
    });
    try {
      await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/loan_trackers/bank_cases/${selectedBankCase.code}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(body),
      }));
    } catch (err) {
      await this.setLoading(false);
      await this.setComponentState({
        selectedBankCase: null,
        updateStatus: '',
      });
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    const query = decodeSearch(this.props.location.search);
    store.dispatch(push(`/bookings/${this.props.bookingID}/?${encodeSearch(query)}`));
    store.dispatch(flashSuccessMessage({
      header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
      message: `${t('{{bankName}}\'s case is successfully updated', { bankName: selectedBankCase.bank.shortName, ns: TRANSLATION_FILES.translation })}.`,
    }));
    await this.setComponentState({
      selectedBankCase: null,
      updateStatus: '',
    });
  }
  async nudgeBankCase(bankCase) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    try {
      await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/loan_trackers/bank_cases/${bankCase.code}/nudge/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    const query = decodeSearch(this.props.location.search);
    store.dispatch(push(`/bookings/${this.props.bookingID}/?${encodeSearch(query)}`));
    store.dispatch(flashSuccessMessage({
      header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
      message: `${t('{{bankName}}\'s case is successfully nudged', { bankName: bankCase.bank.shortName, ns: TRANSLATION_FILES.translation })}.`,
    }));
  }
  isHLBCampaign = () => {
    const auth = this.props.auth;
    const project = this.props.project;

    return !!(auth &&
      auth.companyBranch &&
      auth.companyBranch.isExternal && project && project.hlbCampaignIsEnabled);
  }
  handleGetStarted = (data) => {
    const { t } = this.props;
    this.setState({
      id: data.id || LoanTracker.defaultData.id,
      leadDropID: data.leadDropID || LoanTracker.defaultData.leadDropID,
      code: data.code || LoanTracker.defaultData.code,
    }, () => {
      this.checkBankCasesActivity();
      const { store } = this.context;
      let header = 'Consent Pin sent to purchaser';
      let message = 'Valid for 72 hours';
      if (this.state.id > 0) {
        header = 'PIN confirmed';
        message = 'Proceed to add bankers';
      }
      if (this.props.consentTypeID !== '1') {
        store.dispatch(flashSuccessMessage({
          header: t(header, { ns: TRANSLATION_FILES.translation }),
          message: `${t(message, { ns: TRANSLATION_FILES.translation })}.`,
        }));
      }
    });
  }
  handleShowAddBanker = (e) => {
    e.preventDefault();
    this.setState({
      showAddBanker: true,
    });
  }
  handleCloseAddBanker = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAddBanker: false,
    });
  }
  handleAddBanker = (e, additionalBankers) => {
    e.preventDefault();
    let { bankCases } = this.state;
    const newBankBases = additionalBankers.map(banker => ({
      bank: banker.bank,
      bankerID: banker.id,
      banker,
    }));
    if (this.state.id < 1) {
      bankCases = this.state.oriBankCases.concat(newBankBases);
    }
    this.setState({
      bankCases,
      additionalBankers,
      showAddBanker: false,
    }, () => {
      this.checkBankCasesActivity(bankCases);
      if (this.state.id > 0) {
        this.addBanker(newBankBases);
      }
    });
  }
  handleAddBankerDrop = (e, additionalBankers) => {
    e.preventDefault();
    const newBankDropCases = additionalBankers.map(banker => ({
      bank: banker.bank,
      bankerID: banker.id,
      banker,
    }));
    if (this.state.leadDropID > 0) {
      this.addBanker(newBankDropCases, true);
    }
  }
  handleShowInviteBanker = (e) => {
    e.preventDefault();
    this.setState({
      showInviteBanker: true,
    });
  }
  handleCloseInviteBanker = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showInviteBanker: false,
    });
  }
  handleInviteBanker = (e, validation, banker) => {
    e.preventDefault();
    if (this.state.id > 0) {
      this.inviteBanker(validation, banker);
    }
  }
  activeBankCases = bankCase => (
    (!bankCase.leadDropID && (
    bankCase.status.startsWith('new') ||
    bankCase.status.startsWith('pending') ||
    bankCase.status.startsWith('approved') ||
    bankCase.status === 'reject_wrong_info')) ||
    bankCase.leadDropID > 0
  );
  checkBankCasesActivity(bankCases = this.state.allBankCases) {
    const { leadBankersLimit } = this.state;
    let activeCount = 0;
    let bankersCount = 0;
    if (this.state.id > 0) {
      if (leadBankersLimit > 0) {
        activeCount = bankCases.filter(this.activeBankCases).length;
        if (activeCount < leadBankersLimit) {
          bankersCount = leadBankersLimit - activeCount;
        }
      }
    }
    if (bankersCount !== this.state.bankersCount) {
      this.setState({ bankersCount });
    }
  }
  checkBankers = (banker, bankers) => {
    const index = bankers.findIndex(i => i.id === banker.id);
    if (index > -1) {
      return false;
    }
    if (this.state.leadBankersLimit > 0 && bankers.length >= this.state.bankersCount) {
      return true;
    }
    const { allBankCases } = this.state;
    const bankerIDs = allBankCases.map(bankCase => bankCase.bankerID);
    const activeBankIDs = allBankCases.filter(this.activeBankCases)
      .map(bankCase => parseInt(bankCase.banker.bankID, 10));
    return bankers.some(b => b.bankID === banker.bankID) ||
    bankerIDs.some(b => b === banker.id) ||
    activeBankIDs.some(b => b === parseInt(banker.bankID, 10)) ||
    (this.props.bankerOnCheck && this.props.bankerOnCheck(banker));
  }
  checkSelectedBankers = (banker) => {
    const { allBankCases } = this.state;
    return allBankCases.some(bc => bc.bankerID === banker.id);
  }
  checkBanks = (bank) => {
    const { allBankCases } = this.state;
    const activeBankIDs = allBankCases.filter(this.activeBankCases)
      .map(bankCase => parseInt(bankCase.banker.bankID, 10));
    return activeBankIDs.some(b => b === parseInt(bank.id, 10));
  }
  handleDisplayAddBankerContent = (e) => {
    e.preventDefault();
    const showContent = this.state.displayAddBankerContent;
    this.setState({ displayAddBankerContent: !showContent });
  }
  handleChangeStatus = (selectedBankCase, updateStatus = '') => {
    if (selectedBankCase.status !== updateStatus) {
      this.setState({
        selectedBankCase,
        updateStatus,
        showUpdateBankCase: true,
      });
    }
  }
  handleCloseUpdateBankCase = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showUpdateBankCase: false,
    });
  }
  handleShowCaseStatus = (e, bankCase) => {
    e.preventDefault();
    this.setState({ showBankCaseStatesModal: true, selectedBankCase: bankCase });
  }
  handleCloseCaseStatus = (e, newStatus) => {
    if (e) { e.preventDefault(); }
    const { selectedBankCase } = this.state;
    if (newStatus !== '' &&
    newStatus !== selectedBankCase.status) {
      this.setState({
        updateStatus: newStatus,
        showUpdateBankCase: true,
      });
    } else {
      this.setState({
        showBankCaseStatesModal: false,
        selectedBankCase: null });
    }
  }
  handleUpdateBankCase = (e, statusNote = '', loanAmount = '0') => {
    const { store } = this.context;
    const { t } = this.props;
    const { updateStatus } = this.state;
    if (updateStatus === 'success_li_issued' && Number(loanAmount) <= 0) {
      store.dispatch(flashErrorMessage({ message: t('Loan Amount is required', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    this.setState({
      showUpdateBankCase: false,
      showBankCaseStatesModal: false,
    }, () => {
      this.updateBankCase(statusNote, loanAmount);
    });
  }
  handleRemoveBanker = (index) => {
    const { bankCases } = this.state;
    bankCases.splice(index, 1);
    const additionalBankers = bankCases.map(bc => bc.banker);
    this.setState({ bankCases, additionalBankers }, () => {
      this.checkBankCasesActivity(bankCases);
    });
  }
  handleNudge = (bankCase) => {
    this.nudgeBankCase(bankCase);
  }
  checkBankCaseUserIsActive = bankCase => bankCase.banker.user.statusID === '100'
  renderDisabledText = () => {
    const { bookingStatusID } = this.props;
    switch (bookingStatusID) {
      case 'cancelled_availability':
      case 'cancelled_developer':
        return 'Cancelled';
      case 'expired':
        return 'Expired';
      case 'sold_spa_signed':
      default:
        return 'Sold';
    }
  }
  renderMessage() {
    const { t } = this.props;
    let list = [];
    if (this.state.id > 0 && this.state.code !== '') {
      list = '';
    } else {
      list = [
        t('Inform purchaser that their basic contact information will be shared to bankers'),
        t('PIN will to be sent to purchaser’s registered mobile number (Valid for 72 hours)'),
        t('Purchaser needs to send this to you to confirm consent'),
      ];
    }
    return list;
  }
  render() {
    const {
      bankCaseStates,
      disabled,
      isCashBuyer,
      isNotAuthorizedToInviteBanker,
      leadStatus,
      projectAssignBankCasesStatus,
      projectCurrencies,
      projectID,
      hasSuccessBankCase,
      t,
    } = this.props;
    const { bookingStatusID, displayAddBankerContent, leadDropID } = this.state;
    const list = this.renderMessage();
    return (
      <div className="ui grid loan-tracker">
        <BankCaseStates
          open={this.state.showBankCaseStatesModal}
          onClose={this.handleCloseCaseStatus}
          customerName={this.state.preferredName}
          activeStatus={this.state.selectedBankCase ? this.state.selectedBankCase.status : ''}
        />
        <BankersList
          project={this.props.project}
          bankerSelectionTabs={this.props.bankerSelectionTabs}
          open={this.state.showAddBanker}
          onClose={this.handleCloseAddBanker}
          onConfirm={(leadDropID > 0 && projectAssignBankCasesStatus !== '' && projectAssignBankCasesStatus === 'booked' && bookingStatusID === 'reserved') ? this.handleAddBankerDrop : this.handleAddBanker}
          projectID={projectID}
          bankerOnCheck={this.checkBankers}
          bankerOnCheckSelected={this.checkSelectedBankers}
          limit={this.state.bankersCount}
          selected={this.state.additionalBankers}
          bankCases={this.state.bankCases}
          extraNode={!isNotAuthorizedToInviteBanker && (
            <Button
              floated="left"
              onClick={this.handleShowInviteBanker}
              content="Invite"
            />
          )}
        />
        <InviteBankerForm
          ref={(ref) => { this.form = ref; }}
          open={this.state.showInviteBanker}
          onClose={this.handleCloseInviteBanker}
          onConfirm={this.handleInviteBanker}
          bankOnCheck={this.checkBanks}
        />
        <UpdateCaseStatus
          open={this.state.showUpdateBankCase}
          onClose={this.handleCloseUpdateBankCase}
          onConfirm={this.handleUpdateBankCase}
          bankerName={this.state.selectedBankCase ?
            this.state.selectedBankCase.banker.name : ''
          }
          statusName={bankCaseStates && this.state.updateStatus.length > 0 ?
            bankCaseStates.data.find(s => s.state === this.state.updateStatus).shortName
            : this.state.updateStatus
          }
          loanAmount={this.state.selectedBankCase ?
            `${bankCaseLoanAmount(this.state.selectedBankCase)}` : '0'
          }
          spaValue={this.state.bookingSPAValue}
        />
        {
          disabled ? (
            <div className="row">
              <div className="center aligned sixteen wide column">
                <Header
                  as="h2"
                  style={{
                    margin: '1em 0',
                  }}
                >
                  {t('Booking is {{status}}', { ns: TRANSLATION_FILES.screens, status: t(this.renderDisabledText(), { ns: TRANSLATION_FILES.constants }).toLowerCase() })}.
                </Header>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="center aligned sixteen wide column">
                <Step.Group ordered fluid>
                  <Step
                    completed={this.state.leadDropID > 0 || this.props.consentTypeID === '1'}
                    active={this.state.leadDropID === 0}
                    title={t(this.props.consentTypeID !== '1' ? 'Get Consent' : 'Get Started')}
                  />
                  <Step
                    completed={this.state.id > 0 && this.state.code !== ''}
                    active={this.state.leadDropID > 0 && this.state.id === 0}
                    title={t('Verify')}
                  />
                  <Step
                    completed={this.state.id > 0 && this.state.code !== '' && this.state.bankCases.length > 0}
                    active={this.state.id > 0 && this.state.code !== '' && this.state.bankCases.length < 1}
                  >
                    <Step.Content>
                      <span style={{ fontSize: '1.14285714em', fontWeight: 700 }}>{t('Add Banker')}</span>
                    </Step.Content>
                  </Step>
                </Step.Group>
              </div>
              <div style={{ marginTop: '0.5em' }} className="left aligned sixteen wide column">
                {
                  (list.length > 0 && this.props.consentTypeID !== '1') ? (
                    <List
                      bulleted
                      items={list}
                      style={{
                        marginTop: '0.5em',
                        marginBottom: '0.5em',
                      }}
                    />
                  ) : null
                }
              </div>
            </div>
          )
        }
        {
          this.isHLBCampaign() && <div className="row" style={{ paddingTop: '0em' }}>
            <div className="sixteen wide column" style={{ display: 'flex', justifyContent: 'center', marginTop: '0.5em' }}>
              <HLBCampaignCalloutBanner />
            </div>
          </div>
        }
        {
          this.state.id > 0 && this.state.code !== '' && displayAddBankerContent ? (
            <div className="row" style={{ marginBottom: '1rem' }}>
              <div className="sixteen wide column">
                {
                  this.state.hasDropCase ? (
                    <Grid.Column className="loan-tracker-warning-col">
                      <Label>
                        <Icon name="warning sign" color="yellow" />
                        {t('Please note that banker will receive the case only after the booking is confirmed')}.
                      </Label>
                    </Grid.Column>
                  ) : ''
                }
                <Grid columns={3} stretched stackable doubling>
                  {
                    this.state.allBankCases.map((bankCase, idx) => (
                      <Grid.Column className={bankCase.leadDropID > 0 ? 'loan-tracker-disabled' : ''} key={idx}>
                        <Segment className={bankCase.leadDropID > 0 || this.checkBankCaseUserIsActive(bankCase) ? null : 'inactive-case'}>
                          {
                            bankCase.leadDropID > 0 || bankCase.status ? (
                              <Label
                                attached="top"
                                color={!bankCase.leadDropID ? this.getColor(bankCase.status) : this.getPendingDeveloperApprovalCaseColor()}
                              >
                                {
                                  (bankCase.leadDropID > 0 || this.checkBankCaseUserIsActive(bankCase)) ? (
                                    <Dropdown
                                      selectOnBlur={false}
                                      fluid inline
                                      floating scrolling className="icon"
                                      onClick={e => this.handleShowCaseStatus(e, bankCase)}
                                      text={!bankCase.leadDropID ?
                                        t(this.getCaseText(0, bankCase.status), { ns: TRANSLATION_FILES.constants })
                                        : t(this.getCaseText(bankCase.leadDropID, ''), { ns: TRANSLATION_FILES.constants })}
                                      disabled={
                                        disabled ||
                                        bankCase.leadDropID > 0 ||
                                        bankCase.status === 'reject_lo_signed_other_bank'
                                      }
                                    />
                                  ) : bankCaseStates.data.find(s =>
                                    s.state === bankCase.status).shortName
                                }
                              </Label>
                            ) : null
                          }
                          <Grid>
                            {
                              this.state.id < 1 ? (
                                <Grid.Row>
                                  <Grid.Column width={16} textAlign="right">
                                    <Label
                                      as="button"
                                      attached="top right"
                                      color="red"
                                      size="mini"
                                      onClick={() => this.handleRemoveBanker(idx)}
                                    >
                                      <Icon name="remove" style={{ margin: 0 }} />
                                    </Label>
                                  </Grid.Column>
                                </Grid.Row>
                              ) : null
                            }
                            <Grid.Row>
                              <Grid.Column width={8} textAlign="left">
                                <Header as="h4">
                                  {
                                    bankCase.banker.directToBank && (bankCase.bank && bankCase.bank.logoSrc) ? (
                                      <Header.Content style={{ display: 'inline-flex', alignItems: 'center' }}>
                                        <Image src={bankCase.bank.logoSrc} style={{ maxHeight: '35px' }} />
                                        {
                                          bankCase.bank.isExclusive ? (
                                            <Header.Subheader style={{ marginLeft: '0.5em' }}>
                                              <Image src={icPreferredGreen} height="15" style={{ maxWidth: '20px' }} />
                                            </Header.Subheader>
                                          ) : null
                                        }
                                      </Header.Content>
                                    ) : (
                                      <Header.Content>
                                        {bankCase.banker.name}
                                        <Header.Subheader>
                                          <p>{bankCase.banker.preferredName}</p>
                                          <Phone
                                            mobilePrefix={bankCase.banker.mobilePrefix}
                                            mobile={bankCase.banker.mobile}
                                          />
                                        </Header.Subheader>
                                      </Header.Content>
                                    )
                                  }
                                </Header>
                              </Grid.Column>
                              <Grid.Column width={8}>
                                <Header
                                  textAlign="right"
                                  as="h4"
                                  content={!bankCase.leadDropID ? bankCase.bank.shortName : bankCase.banker.bank.shortName}
                                  subheader={bankCase.leadDropID || this.checkBankCaseUserIsActive(bankCase) ?
                                    bankCase.banker.bankBranch.name : null}
                                />
                              </Grid.Column>
                            </Grid.Row>
                            {
                              !bankCase.leadDropID &&
                              this.checkBankCaseUserIsActive(bankCase) &&
                              bankCase.status === 'success_li_issued' ? (
                                <Grid.Row verticalAlign="middle">
                                  <Grid.Column width={5} textAlign="left">
                                    <Grid.Row className="bankcasecard-subheader">
                                      {t('Loan Margin')}
                                    </Grid.Row>
                                    <Grid.Row>
                                      {this.getLoanMargin(bankCase.loanAmount)}
                                    </Grid.Row>
                                  </Grid.Column>
                                  <Grid.Column width={5} textAlign="left" style={{ padding: 0 }}>
                                    <Grid.Row className="bankcasecard-subheader">
                                      {t('Loan Amount')}
                                    </Grid.Row>
                                    <Grid.Row>
                                      <LoanAmount
                                        projectCurrencies={projectCurrencies}
                                        format=""
                                        amount={bankCase.loanAmount > 0 ? bankCase.loanAmount : 0}
                                        prefix={<CurrencySymbol />}
                                      />
                                    </Grid.Row>
                                  </Grid.Column>
                                  {
                                    bankCase.latestUpdateAt || bankCase.createdAt ? (
                                      <Grid.Column width={6} textAlign="right">
                                        <Grid.Row className="bankcasecard-subheader">
                                          {t('Last Updated')}
                                        </Grid.Row>
                                        <Grid.Row>
                                          <Timestamp
                                            timestamp={bankCase.latestUpdateAt ?
                                              bankCase.latestUpdateAt : bankCase.createdAt
                                            }
                                            precise
                                          />
                                        </Grid.Row>
                                      </Grid.Column>
                                    ) : null
                                  }
                                </Grid.Row>
                              ) : (
                                <Grid.Row verticalAlign="middle">
                                  <Grid.Column width={8} textAlign="left">
                                    {
                                      !bankCase.leadDropID &&
                                      this.checkBankCaseUserIsActive(bankCase) &&
                                      bankCase.status !== 'success_li_issued' ? (
                                        <Button
                                          icon="hand pointer"
                                          content={t('Nudge')}
                                          inverted={moment().isAfter(bankCase.nudgeAt)}
                                          color={moment().isAfter(bankCase.nudgeAt) ? 'grey' : null}
                                          onClick={() => this.handleNudge(bankCase)}
                                          disabled={disabled ||
                                            leadStatus === 'success' ||
                                            bankCase.status.startsWith('success') ||
                                            bankCase.status.startsWith('reject') ||
                                            moment().isBefore(bankCase.nudgeAt) ||
                                            hasSuccessBankCase
                                          }
                                        />
                                      ) : ''
                                    }
                                    {
                                      bankCase.leadDropID > 0 ? (
                                        <Label size="small" color="yellow" content={t('Pending developer\'s approval')} />
                                      ) : ''
                                    }
                                    {
                                      !bankCase.leadDropID && !this.checkBankCaseUserIsActive(bankCase) ? (
                                        <Label size="small" color="yellow" content={t('Pending Registration')} />
                                      ) : ''
                                    }
                                  </Grid.Column>
                                  {
                                    bankCase.latestUpdateAt || bankCase.createdAt ? (
                                      <Grid.Column width={8} textAlign="right">
                                        <Grid.Row className="bankcasecard-subheader">
                                          {t('Last Updated')}
                                        </Grid.Row>
                                        <Grid.Row>
                                          <Timestamp
                                            timestamp={bankCase.latestUpdateAt ?
                                              bankCase.latestUpdateAt : bankCase.createdAt
                                            }
                                            precise
                                          />
                                        </Grid.Row>
                                      </Grid.Column>
                                    ) : null
                                  }
                                </Grid.Row>
                              )
                            }
                          </Grid>
                        </Segment>
                      </Grid.Column>
                    ))
                  }
                  {
                    ((
                      this.state.leadBankersLimit === 0 ||
                      this.state.bankersCount > 0
                    ) && !disabled && !hasSuccessBankCase) ?
                      Array(this.state.bankersCount || 1).fill('Bankers').map((ele, key) => (
                        <Grid.Column key={key} only={key > 0 ? 'tablet computer' : null}>
                          <Segment
                            style={{
                              display: 'inline-flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            secondary
                          >
                            {
                              key === 0 && !isCashBuyer ? (
                                <Button
                                  positive
                                  onClick={this.handleShowAddBanker}
                                  icon="add"
                                  content={t('Bankers')}
                                />
                              ) : null
                            }
                          </Segment>
                        </Grid.Column>
                      )) : null
                  }
                </Grid>
              </div>
            </div>
          ) : null
        }
        {
          this.state.id < 1 && !disabled && !hasSuccessBankCase ?
            <GetStarted
              id={this.state.id}
              leadDropID={this.state.leadDropID}
              code={this.state.code}
              bookingID={this.props.bookingID}
              consentTypeID={this.props.consentTypeID}
              token={this.props.token}
              onSubmit={this.handleGetStarted}
              bankCases={this.state.bankCases}
              setLoading={this.setLoading}
              mobilePrefix={this.props.mobilePrefix}
              mobile={this.props.mobile}
            />
          : null
        }
      </div>
    );
  }
}

export default withTranslation(namespaces)(connect(LoanTracker.mapStateToProps)(LoanTracker));



// WEBPACK FOOTER //
// ./src/containers/LoanTracker/LoanTracker.jsx